import React from "react";
import { Doughnut } from "react-chartjs-2";

const LEGENDA = {display: true, position: "bottom", fullWidth: true, reverse: false}, 
  OPTION = {
    tooltips: {
      callbacks: {
        label: function(tooltipItem, data) {
          let dataset = data.datasets[tooltipItem.datasetIndex],
            meta = dataset._meta[Object.keys(dataset._meta)[0]],
            total = meta.total,
            currentValue = dataset.data[tooltipItem.index],
            percentage = parseFloat((currentValue/total*100).toFixed(1));
          return currentValue + ' (' + percentage + '%)';
        },
        title: function(tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        }
      }
    }
  };

export default class DoughnutGraph extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      dados: {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: ["#dc3545", "#ffc107", "#17a2b8", "#28a745"],
          hoverBackgroundColor: ["#bd2130", "#d39e00", "#117a8b", "#1e7e34"]
        }]
      }
    }
  }

  componentDidMount () {
    if (this.props.data) {
      let dados = this.state.dados,
        totalNotas = this.props.data.ruim + this.props.data.bom + this.props.data.otimo + this.props.data.excelente;
      dados.labels.push(`Ruim - ${this.calcularPorcentagem(this.props.data.ruim, totalNotas)}%`, `Bom - ${this.calcularPorcentagem(this.props.data.bom, totalNotas)}%`, `Ótimo - ${this.calcularPorcentagem(this.props.data.otimo, totalNotas)}%`, `Excelente - ${this.calcularPorcentagem(this.props.data.excelente, totalNotas)}%`);
      dados.datasets[0].data = [this.props.data.ruim, this.props.data.bom, this.props.data.otimo, this.props.data.excelente];
      this.setState({dados});
    }
  }

  calcularPorcentagem (nota, total) {
    return ((100 * nota) / total).toFixed(2);
  }

  render () {
    return (
      <div>
        <Doughnut data={this.state.dados} legend={LEGENDA} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Graficos/Doughnut.js